/**
 * The classes and features an order may ask for, as everybody at the desk may read them.
 *
 * The administrator's fleet screens read the same lists from their own endpoints; this one
 * is open to every member of staff, because a dispatcher taking an order is offered the
 * firm's list and nothing else about its cars.
 */

import { request, type Schema } from '@taxi/api-client';

export interface VehicleClass {
  code: string;
  displayName: string;
  minimumSeats: number;
  sortOrder: number;
}

/** `namedByFirm` says a starter was renamed, and is then said by `displayName` (#462). */
export type VehicleFeature = Schema<'FleetFeature'>;

export type VehicleChoices = Schema<'VehicleChoices'>;

export const vehicleChoicesApi = {
  get: () => request<VehicleChoices>('/api/fleet/vehicle-choices'),
};
